import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToiletSeat = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "toilet-seat" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,12.753h4.5a1.5,1.5,0,0,0,1.5-1.5v-9a1.5,1.5,0,0,0-1.5-1.5h-3a1.5,1.5,0,0,0-1.5,1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,9.753a1.5,1.5,0,0,0,0,3h12v-3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.2,15.6a3,3,0,0,0,2.047-2.845H3.75a8.25,8.25,0,0,0,4.5,7.35l-.75,3.15h9.75V17.035A1.49,1.49,0,0,1,18.2,15.6Z"
		})
	]
});
export default SvgToiletSeat;
